import { useCallback } from 'react';

import {
  Button,
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle
} from 'design-system';
import { Crown } from 'lucide-react';
import { Link } from 'react-router';

import { useAppDispatch } from '@/store/hooks';
import { closeDrawer } from '@/store/slices/drawer.slice';

/* oxlint-disable jsx-a11y/prefer-tag-over-role -- The fixed div-based EmptyTitle and Base UI Button render APIs require explicit roles to preserve the required semantic heading and React Router link. */
const PremiumWidgetDenied = () => {
  const dispatch = useAppDispatch();

  const handleUpgrade = useCallback(() => {
    dispatch(closeDrawer());
  }, [dispatch]);

  return (
    <div className='relative h-[542px] min-w-0 overflow-hidden'>
      <div
        aria-hidden='true'
        className="absolute inset-0 scale-[1.05] bg-[url('/img/preview/history-chart.png')] bg-center bg-cover blur-[5px]"
      />
      <Empty className='relative z-10 h-full min-h-0 border-0'>
        <EmptyHeader>
          <EmptyMedia variant='icon'>
            <Crown />
          </EmptyMedia>
          <EmptyTitle
            role='heading'
            aria-level={2}
          >
            Premium market widget
          </EmptyTitle>
          <EmptyDescription>This feature isn't included in your plan.</EmptyDescription>
          <EmptyDescription>Upgrade for advanced functionality.</EmptyDescription>
        </EmptyHeader>
        <EmptyContent>
          <Button
            nativeButton={false}
            render={
              <Link
                role='link'
                to='/manage-subscription'
              />
            }
            onClick={handleUpgrade}
          >
            Upgrade plan
          </Button>
        </EmptyContent>
      </Empty>
    </div>
  );
};
/* oxlint-enable jsx-a11y/prefer-tag-over-role */

export default PremiumWidgetDenied;
